import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';

export default {
  init() {},
  finalize() {
    // JavaScript to be fired on loaded

    // Gifts
    const giftsWrapper = $('#global-gifts-wrapper');
    if (giftsWrapper.length) {
      // Cancel token source
      let cancelTokenSource = null;

      const handleGiftsResults = function(offset = 0) {
        // Cancel previous request if it exists
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const countLabel = $('#global-gifts-count-label');
        const skeleton = $('#global-gifts-skeleton');
        const loadMoreButtonWrapper = $('#global-gifts-load-more-button-wrapper');
        let page = parseInt(giftsWrapper.data('page'), 10);
        const perPage = parseInt(giftsWrapper.data('per-page'), 10);
        const params = helpers.getParameters();

        if (offset === 0) {
          countLabel.text('');
          giftsWrapper.html('');
        }
        skeleton.show();
        loadMoreButtonWrapper.hide();

        // Params
        const data = {
          'action': constants.ACTION_GET_GLOBAL_GIFTS,
          'occasion': params['occasion'] || '',
          'recipient': params['recipient'] || '',
          'location': params['location'] || '',
          'brand': params['brand'] || '',
          'deliveryMethod': params['delivery_method'] || '',
          'sort': params['sort'] || '',
          'search': params['search'] || '',
          'offset': offset,
        };

        // Send request
        axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
          cancelToken: cancelTokenSource.token,
        }).then((axiosResponse) => {
          if (200 === axiosResponse.status) {
            const response = axiosResponse.data;

            skeleton.hide();

            if (response.success) {
              const count = response.data['count'];
              const html = response.data['html'];

              if (html.length) {
                if (offset === 0) {
                  countLabel.text(`Showing ${count} results`);
                  giftsWrapper.html(html);
                  page = 1;
                  offset = perPage;
                } else {
                  giftsWrapper.append(html);

                  // Increment page and offset
                  page += 1;
                  offset += perPage;
                }

                // Update attributes
                giftsWrapper.data('page', page).attr('data-page', page);
                giftsWrapper.data('offset', offset).attr('data-offset', offset);

                // Update URL
                params['page_number'] = page;
                helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

                if (offset >= count) {
                  loadMoreButtonWrapper.hide();
                } else {
                  loadMoreButtonWrapper.show();
                }
              } else {
                loadMoreButtonWrapper.hide();
              }
            } else {
              loadMoreButtonWrapper.hide();
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      };

      const giftOccasionsFilter = $('#gift-occasions-filter');
      if (giftOccasionsFilter.length) {
        giftOccasionsFilter.on('select2:select', function() {
          const _this = $(this);
          const selectedVal = _this.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['occasion'] = selectedVal;
          } else {
            delete params['occasion'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_OCCASION_FILTER_CHANGED, [selectedVal]);
        }).on('select2:unselect', function() {
          const params = helpers.getParameters();

          delete params['occasion'];

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_OCCASION_FILTER_CHANGED, ['']);
        });
      }

      const giftRecipientsFilter = $('#gift-recipients-filter');
      if (giftRecipientsFilter.length) {
        giftRecipientsFilter.on('select2:select', function() {
          const _this = $(this);
          const selectedVal = _this.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['recipient'] = selectedVal;
          } else {
            delete params['recipient'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_RECIPIENT_FILTER_CHANGED, [selectedVal]);
        }).on('select2:unselect', function() {
          const params = helpers.getParameters();

          delete params['recipient'];

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_RECIPIENT_FILTER_CHANGED, ['']);
        });
      }

      const giftLocationsFilter = $('#gift-locations-filter');
      if (giftLocationsFilter.length) {
        giftLocationsFilter.on('select2:select', function() {
          const _this = $(this);
          const selectedVal = _this.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['location'] = selectedVal;
          } else {
            delete params['location'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_LOCATION_FILTER_CHANGED, [selectedVal]);
        }).on('select2:unselect', function() {
          const params = helpers.getParameters();

          delete params['location'];

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_LOCATION_FILTER_CHANGED, ['']);
        });
      }

      const giftBrandsFilter = $('#gift-brands-filter');
      if (giftBrandsFilter.length) {
        giftBrandsFilter.on('select2:select', function() {
          const _this = $(this);
          const selectedVal = _this.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['brand'] = selectedVal;
          } else {
            delete params['brand'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_BRAND_FILTER_CHANGED, [selectedVal]);
        }).on('select2:unselect', function() {
          const params = helpers.getParameters();

          delete params['brand'];

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_BRAND_FILTER_CHANGED, ['']);
        });
      }

      const giftDeliveryMethodsFilter = $('.gift-delivery-methods-filter-item input[name="deliveryMethod[]"]');
      if (giftDeliveryMethodsFilter) {
        giftDeliveryMethodsFilter.on('change', function() {
          const checked = $('.gift-delivery-methods-filter-item input[name="deliveryMethod[]"]:checked');
          const selectedVal = [];

          if (checked.length) {
            checked.each(function() {
              const _this = $(this);
              const val = _this.val();

              selectedVal.push(val);
            });
          }

          const params = helpers.getParameters();

          if (selectedVal.length) {
            params['delivery_method'] = selectedVal.join(',');
          } else {
            delete params['delivery_method'];
          }

          // Push params to URL
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_DELIVERY_METHOD_FILTER_CHANGED, [selectedVal.join(',')]);
        });
      }

      const giftSortItems = $('#gift-sort-items');
      if (giftSortItems.length) {
        giftSortItems.on('select2:select', function() {
          const _this = $(this);
          const selectedVal = _this.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['sort'] = selectedVal;
          } else {
            delete params['sort'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_SORT_CHANGED, [selectedVal]);
        }).on('select2:unselect', function() {
          const params = helpers.getParameters();

          delete params['sort'];

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleGiftsResults();

          $(document).trigger(constants.EVENT_GIFTS_VOUCHER_TYPE_FILTER_CHANGED, ['']);
        });
      }

      const giftsSearchInput = $('.gifts-search-input');
      if (giftsSearchInput.length) {
        const searchIcon = giftsSearchInput.siblings('.search-icon');
        const clearButton = giftsSearchInput.siblings('.clear-button');
        let timeout = 0;

        giftsSearchInput.on('keyup', function() {
          const _this = $(this);
          const selectedVal = _this.val();

          if (selectedVal.length > 0) {
            searchIcon.hide();
            clearButton.show();
          } else {
            searchIcon.show();
            clearButton.hide();
          }

          clearTimeout(timeout);

          timeout = setTimeout(function() {
            const params = helpers.getParameters();

            if (selectedVal !== '') {
              params['search'] = selectedVal;
            } else {
              delete params['search'];
            }

            // Push params to url
            helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

            handleGiftsResults();

            $(document).trigger(constants.EVENT_GIFTS_SEARCH_FILTER_CHANGED, [selectedVal]);
          }, 500);
        });

        clearButton.on('click', function() {
          giftsSearchInput.val('');
          giftsSearchInput.trigger('keyup');
        });
      }

      const loadMoreButton = $('#global-gifts-load-more-button');
      if (loadMoreButton.length) {
        loadMoreButton.on('click', function(e) {
          e.preventDefault();

          const offset = parseInt(giftsWrapper.data('offset'), 10) || 0;

          handleGiftsResults(offset);
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGlobalGiftCardsV2.js